import Address from '../shared/Address';

export default class ManufacturerWriteDTO {
    public id: number | undefined;
    public name: string | undefined;
    public address: Address;
    public mail: string | undefined;
    public note: string | undefined;
    public contractExpirationDate: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.address = data['address']
            ? new Address(data['address'])
            : new Address({});
        this.mail = data['mail'] || undefined;
        this.note = data['note'] || undefined;
        this.contractExpirationDate = data['contractExpirationDate'] || undefined;
    }
}
